import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL

export const documentApiService = {
    checkUploaded
}

function checkUploaded(claimId) {
    return axios.get(baseUrl + '/api/admin/v1/document/uploaded/' + claimId)
}
